import { toast } from 'sonner';
import { useNavigate } from 'react-router';
import { Plus } from 'lucide-react';
import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';

import { getApiError } from 'src/utils/errors';
import { EscrowPartyTypeEnum, AgreementFormEnum } from 'src/graphql/schema';
import { SoftwareEscrowCreateDocument } from 'src/graphql/actions/softwareEscrow/softwareEscrowCreate.mutation';
import { SoftwareEscrowsDocument } from 'src/graphql/actions/softwareEscrow/softwareEscrows.query';
import { Button } from '@/components/ui/button';
import { apolloClient as client } from 'src/graphql/client/apollo-client';

import { useSoftwareEscrowNewContext } from '../model';

const refetchEscrows = () => {
  client.cache.evict({ fieldName: 'softwareEscrows' });
  client.cache.gc();
  client.refetchQueries({
    include: [SoftwareEscrowsDocument],
  });
};

const CreateAction = () => {
  const { onSubmit, isValid } = useSoftwareEscrowNewContext();
  const navigate = useNavigate();
  const [createEscrow, { loading }] = useMutation(SoftwareEscrowCreateDocument, {
    onCompleted: refetchEscrows,
  });

  const onSave = useCallback(() => {
    onSubmit(async ({ escrowRole, agreementForm }) => {
      try {
        const { data } = await createEscrow({
          variables: {
            escrowRole: escrowRole as EscrowPartyTypeEnum,
            agreementForm: agreementForm as AgreementFormEnum,
          },
        });
        if (data?.softwareEscrowCreate?.success) {
          navigate(`/software-escrows/onboarding/${data?.softwareEscrowCreate?.softwareEscrow?.id}/members`);
        }
      } catch (e) {
        getApiError(e, toast.error);
      }
    });
  }, [onSubmit, createEscrow, navigate]);

  return (
    <Button disabled={!isValid || loading} onClick={onSave} isLoading={loading}>
      Create <Plus />
    </Button>
  );
};

export default CreateAction;
